import React from 'react';
import CallAPI from '../../../../adminpanel/components/commonComponents/AxiosHelper';

const formUpload = {
    "appendDataForm": {
        "dateColumn": {
            "name": "dateColumn", "label": "Selected Date Column", "text_value": "", "type": "text", "requiredFlag": true, "disabled": true,
        },
        "startDate": {
            "name": "startDate", "label": "Start Date", "type": "date", "text_value": "", "requiredFlag": true,
        },
        "endDate": {
            "name": "endDate", "label": "End Date", "type": "date", "text_value": "", "requiredFlag": true,
        },
        "min_split": {
            "name": "min_split", "label": "Min Split", "type": "dropdown", "options": [
                { "name": "Select Option", "value": "" },
                { "name": "Day", "value": "day" },
                { "name": "Week", "value": "week" },
                { "name": "Month", "value": "month" },
                { "name": "Year", "value": "year" }
            ], "requiredFlag": false
        },
        "data_split": {
            "name": "data_split", "label": "Data Split", "type": "dropdown", "options": [
                { "name": "Select Option", "value": "" },
                { "name": "1", "value": "1" }, { "name": "2", "value": "2" }, { "name": "3", "value": "3" }, { "name": "4", "value": "4" }, { "name": "5", "value": "5" }, { "name": "6", "value": "6" }, { "name": "7", "value": "7" }, { "name": "8", "value": "8" }, { "name": "9", "value": "9" }, { "name": "10", "value": "10" }, { "name": "12", "value": "12" }
            ], "requiredFlag": false
        },
        "filter": {
            "name": "filter", "label": "Filter Table with Table Data", "type": "text", "text_value": "", "requiredFlag": false
        },
        "dataset": {
            "name": "dataset", "label": "Data", "type": "hide", "id": "createFile", "requiredFlag": true
        }
    },
    "overWriteForm": {
        "overwriteType": {
            "name": "overwriteType", "label": "Overwrite Action", "type": "dropdown", "options": [
                { "name": "Select Option", "value": "" },
                { "name": "Overwrite entire table", "value": 'full' },
                { "name": "Overwrite data for file", "value": "file" }
            ], "requiredFlag": true
        },
        "fileName": {
            "name": "fileName", "label": "Select File", "type": "hide", "options": [
                { "name": "Select Option", "value": "" }
            ], "requiredFlag": false,
        },
        "dateColumn": {
            "name": "dateColumn", "label": "Selected Date Column", "text_value": "", "type": "text", "requiredFlag": true, "disabled": true,
        },
        "startDate": {
            "name": "startDate", "label": "Start Date", "type": "hide", "requiredFlag": true,
        },
        "endDate": {
            "name": "endDate", "label": "End Date", "type": "hide", "requiredFlag": true,
        },
        "min_split": {
            "name": "min_split", "label": "Min Split", "type": "dropdown", "options": [
                { "name": "Select Option", "value": "" },
                { "name": "Day", "value": "day" },
                { "name": "Week", "value": "week" },
                { "name": "Month", "value": "month" },
                { "name": "Year", "value": "year" }
            ], "requiredFlag": false
        },
        "data_split": {
            "name": "data_split", "label": "Data Split", "type": "dropdown", "options": [
                { "name": "Select Option", "value": "" },
                { "name": "1", "value": "1" }, { "name": "2", "value": "2" }, { "name": "3", "value": "3" }, { "name": "4", "value": "4" }, { "name": "5", "value": "5" }, { "name": "6", "value": "6" }, { "name": "7", "value": "7" }, { "name": "8", "value": "8" }, { "name": "9", "value": "9" }, { "name": "10", "value": "10" }, { "name": "12", "value": "12" }
            ], "requiredFlag": false
        },
        "limit": {
            "name": "limit", "label": "Limit", "type": "hide", "text_value": "", "requiredFlag": false
        },
        "filter": {
            "name": "filter", "label": "Filter Table with Table Data", "type": "text", "text_value": "", "requiredFlag": false
        },
        "dataset": {
            "name": "dataset", "label": "Data", "type": "file", "id": "createFile", "requiredFlag": true
        },
        "truncateData": {
            "name": "truncateData", "label": "Truncate Data", "type": "hide", "options": [
                { "name": "Yes", "value": true },
                { "name": "No", "value": false }
            ], "requiredFlag": false
        }
    },
    "makeDatasetForm": {
        "datasetName": {
            "name": "datasetName", "label": "Dataset Name", "type": "text", "requiredFlag": true
        },
        "dateColumn": {
            "name": "dateColumn", "label": "Date Column", "type": "dropdown", "requiredFlag": true
        }
    },
    "updateSettingsForm": {
        "virtualTableName": {
            "name": "virtualTableName", "label": "Name", "text_value": "", "type": "hide"
        },
        "status": {
            "name": "status", "label": "Sync Status", "type": "dropdown", "options": [
                { "name": "Select Option", "value": "" },
                { "name": "On", "value": true },
                { "name": "Off", "value": false }
            ], "requiredFlag": true
        },
        "filePattern": {
            "name": "filePattern", "label": "File Pattern", "type": "hide", "options": [
                { "name": "Select Option", "value": "" },
            ]
        },
        "customFilePattern": {
            "name": "customFilePattern", "type": "hide"
        },
        "freq_type": {
            "name": "freq_type", "label": "Frequency", "type": "dropdown", "options": [
                { "name": "Select Option", "value": "" },
                { "name": "Daily", "value": 'daily' },
                { "name": "Weekly", "value": "week" },
                { "name": "Monthly", "value": "month" },
                { "name": "Yearly", "value": "year" }
            ], "requiredFlag": false
        },
        "timeOfDay": {
            "name": "timeOfDay", "label": "Time of the day", "type": "hide", "step": "1", "requiredFlag": false
        },
        "dayOfWeek": {
            "name": "dayOfWeek", "label": "Day of Week", "type": "hide",
            "options": [{ "name": "Select Option", "value": "" },
            { "name": "Sunday", "value": "sun" },
            { "name": "Monday", "value": "mon" },
            { "name": "Tuesday", "value": "tue" },
            { "name": "Wednesday", "value": "wed" },
            { "name": "Thursday", "value": "thurs" },
            { "name": "Friday", "value": "fri" },
            { "name": "Saturday", "value": "sat" }
            ], requiredFlag: false
        },
        "dayOfMonth": {
            "name": "dayOfMonth", "label": "Day of Month", "type": "hide", "min": "1", "max": "31", requiredFlag: false
        },
        "minsplit": {
            "name": "minsplit", "label": "Min Split", "id": "minsplit", "type": "dropdown", "options": [
                { "name": "Select Option", "value": "" },
                { "name": "Day", "value": "day" },
                { "name": "Week", "value": "week" },
                { "name": "Month", "value": "month" },
                { "name": "Year", "value": "year" }
            ], "requiredFlag": true
        },
        "datasplit": {
            "name": "datasplit", "label": "Data Split", "type": "dropdown", "options": [
                { "name": "Select Option", "value": "" },
                { "name": "1", "value": "1" }, { "name": "2", "value": "2" }, { "name": "3", "value": "3" }, { "name": "4", "value": "4" }, { "name": "5", "value": "5" }, { "name": "6", "value": "6" }, { "name": "7", "value": "7" }, { "name": "8", "value": "8" }, { "name": "9", "value": "9" }, { "name": "10", "value": "10" }, { "name": "12", "value": "12" }
            ], "requiredFlag": false
        },
        "deleteType": {
            "name": "deleteType", "label": "Delete Type", "type": "dropdown", "options": [
                { "name": "Select Option", "value": "" },
                { "name": "YTD", "value": 'ytd' },
                { "name": "MTD", "value": "mtd" },
                { "name": "Calendar Year", "value": "calyear" },
                { "name": "DAILY", "value": "daily" },
                { "name": "No Delete", "value": "nodelete" },
                { "name": "Entire Data", "value": "entire_data" }
            ], "requiredFlag": true
        },
        "time_to_subtract": {
            "name": "time_to_subtract", "label": "Period Gap", "type": "dropdown", "options": [
                { "name": "Select Option", "value": "" },
                { "name": "-1 Day", "value": "-1 day" },
                { "name": "-2 Day", "value": "-2 day" },
                { "name": "-3 Day", "value": "-3 day" },
                { "name": "-4 Day", "value": "-4 day" },
                { "name": "-5 Day", "value": "-5 day" }
            ], "requiredFlag": false
        },
        "limit": {
            "name": "limit", "label": "Limit", "type": "hide", "text_value": "", "requiredFlag": false
        },
        "whereCondition": {
            "name": "whereCondition", "label": "Filter Table with Table Data", "type": "text", "text_value": "", "requiredFlag": false
        }
    },
    "dataQualityForm": {
        "dataQualityType": {
            "name": "dataQualityType", "label": "Select Data Quality Type", "type": "hide", "options": [
                { "name": "Select Option", "value": "" },
                { "name": "Data Quality of Current File", "value": "currentFile" },
                { "name": "Data Quality with Comparison", "value": "compareFile" },
            ], "requiredFlag": true
        },
        "dataType": {
            "name": "dataType", "label": "Data Type", "type": "hide", "options": [
                { "name": "Select Option", "value": "" },
                { "name": "PDF", "value": "pdf" }
            ], "requiredFlag": true
        },
        "compare_type": {
            "name": "compare_type", "label": "Select Compare Type", "text_value": "", "type": "hide", "options": [
                { "name": "Select Option", "value": "" },
                { "name": "Compare with Base Table", "value": "0" },
                { "name": "Compare with Specific File", "value": "2" },
                { "name": "Compare with Last Uploaded File", "value": "1" }
            ], "requiredFlag": true
        },
        "fileName": {
            "name": "fileName", "label": "Select File", "type": "hide", "options": [
                { "name": "Select Option", "value": "" }
            ], "requiredFlag": true,
        },
        "difference": {
            "name": "difference", "label": "Select Columns", "type": "hide", "options": [
                { "name": "Select Option", "value": "" },
                { "name": "All Columns", "value": "false" },
                { "name": "Different Columns", "value": "true" }
            ], "requiredFlag": true
        }
    },
    "mappingForm": {
    },
    "deleteForm": {
        "message": {
            "name": "message", "label": "Are you sure you want to delete?", "type": "text", "requiredFlag": false
        }
    },
    "updateForm": {
        "virtualTableName": {
            "name": "virtualTableName", "label": "Name", "text_value": "", "type": "text"
        },
        "type": {
            "name": "type", "label": "Table Type", "type": "dropdown", "options": [
                { "name": "Select Option", "value": "" },
                { "name": "Transaction", "value": "Transaction" },
                { "name": "Master", "value": "Master" }
            ], "requiredFlag": true
        },
        "default_newColumns": {
            "name": "default_newColumns", "label": "New Column Action", "type": "hide", "options": [
                { "name": "Select Option", "value": "" },
                { "name": "Add Column", "value": "2" },
                { "name": "Ignore Column", "value": "1" },
                { "name": "User Action Needed", "value": "0" },
            ], "requiredFlag": true
        }
    }
}

const mappingDropDown = {
    "name": "mappingType", "type": "dropdown", "options": [
        { "name": "Select Option", "value": "" },
        { "name": "Ignore Column", "value": "ignore" }
    ], "requiredFlag": true
}

const modalConfig = {
    "appendDataModal": {
        "id": "appendDataModal", "form_name": "appendData", "form_id": "appendDataForm", "title": "Append Data", "body": null, "button_name": "Load", buttonType: "submit", "display": true, "buttonId": "uploadFile"
    },
    "overWriteModal": {
        "id": "overWriteModal", "form_name": "overWrite", "form_id": "overWriteForm", "title": "Overwrite Data", "body": null, "button_name": "Upload", buttonType: "submit", "display": true, "buttonId": "uploadFile"
    },
    "updateSettingsModal": {
        "id": "updateSettingsModal", "form_name": "updateSettings", "form_id": "updateSettingsForm", "title": "Pipeline Settings", "body": null, "button_name": "Update", buttonType: "submit", "display": true
    },
    "makeDatasetModal": {
        "id": "makeDatasetModal", "form_name": "makeDataset", "form_id": "makeDatasetForm", "title": "Make As Dataset", "body": null, "button_name": "Create", buttonType: "submit", "display": true
    },
    "dataQualityModal": {
        "id": "dataQualityModal", "form_name": "dataQuality", "form_id": "dataQualityForm", "title": "Data Quality", "body": null, "button_name": "Generate", buttonType: "submit", "display": true
    },
    "deleteModal": {
        "id": "deleteModal", "form_name": "delete", "form_id": "deleteForm", "title": "Delete", "body": null, "button_name": "Delete", buttonType: "submit", "display": true
    },
    "mappingModal": {
        "id": "mappingModal", "form_name": "mapping", "form_id": "mappingForm", "title": "Mapping Required", "body": null, "button_name": "Submit", buttonType: "submit", "display": true, height: "350"
    },
    "updateModal": {
        "id": "updateModal", "form_name": "update", "form_id": "updateForm", "title": "Update Settings", "body": null, "button_name": "Update", buttonType: "submit", "display": true
    }
}

export function ModalDetails(clickName, eventDetails, renderData, setSelectedFiles, setmodalToView, setdataToSend, selectedFiles) {
    let formData = eventDetails.connection_type === 'sftp' ? {} : JSON.parse(JSON.stringify(formUpload[`${clickName}Form`]));
    setSelectedFiles({})
    if (clickName === "appendData") {
        let pull_information = [];
        if (eventDetails.connection_type === 'sftp') {
            formData.connectionId = eventDetails.connectionId;
            formData.connection_type = eventDetails.connection_type;
            formData.connection_name = eventDetails.tableName;
            formData.targetTable = eventDetails.tableName;
            formData.action = "append";
            pull_information.push({
                "action": "append",
            })
        } else {
            let dateColumnSelected = null;
            renderData.map(el => {
                if (eventDetails['tableName'] === el.targetTableName) {
                    dateColumnSelected = JSON.parse(el.information).dateColumn;
                    formData['dateColumn']['text_value'] = dateColumnSelected;
                    pull_information.push({
                        "connectionId": el.connectionId,
                        "clientTableName": el.clientTableName,
                        "connection_type": el.connection_type,
                        "clientDBName": el.clientDBName,
                        "dateColumn": dateColumnSelected,
                        "startDate": null,
                        "endDate": null,
                        "virtualTableName": el.virtualTableName,
                        "targetTable": el.targetTableName,
                        "action": "append",
                    })
                }
            })
            if (eventDetails.connection_type === "manual") {
                formData['dateColumn']['type'] = "hide";
                formData['startDate']['type'] = "hide";
                formData['endDate']['type'] = "hide";
                formData['data_split']['type'] = "hide";
                formData['min_split']['type'] = "hide";
                formData['dataset']['type'] = "newFile";
            }
        }
        setdataToSend({ 'pull_information': [...pull_information] })
    } else if (clickName === "updateSettings") {
        formData = JSON.parse(JSON.stringify(formUpload[`${clickName}Form`]));
        let virtualTableNameSelected = null;
        let update_information = [];
        if (eventDetails.connection_type === 'sftp') {
            formData['filePattern']['type'] = 'dropdown'
            let filePatternOption = eventDetails.fileInfo.pipeline_frequency ? JSON.parse(eventDetails.fileInfo.pipeline_frequency).suggested_pattern : null
            filePatternOption ? filePatternOption && filePatternOption.forEach(el => {
                formData['filePattern']['options'].push({ "name": el, "value": el })
            }) : null
            formData['filePattern']['options'].push({ "name": "Custom", "value": "custom" })
            let finalSuggestion = eventDetails.fileInfo.pipeline_frequency ? JSON.parse(eventDetails.fileInfo.pipeline_frequency).final_suggestion : ""
            finalSuggestion ? formData['customFilePattern']['label'] = `Custom File Pattern (Suggestion: ${finalSuggestion})` : ""
        }
        renderData.map(el => {
            if (eventDetails['tableName'] === el.targetTableName) {
                let masterTable = ['Master', 'master'].indexOf(el.type) > -1
                virtualTableNameSelected = el.virtualTableName;
                formData['virtualTableName']['text_value'] = virtualTableNameSelected;
                if (masterTable) {
                    formData['minsplit']['type'] = 'hide'
                    formData['datasplit']['type'] = 'hide'
                    formData['deleteType']['disabled'] = true
                    formData['limit']['type'] = 'number'
                    formData['time_to_subtract']['type'] = 'hide'
                }
                if (el.pipeline_frequency) {
                    formData['status']['text_value'] = JSON.parse(el.pipeline_frequency).status;
                    formData['freq_type']['text_value'] = JSON.parse(el.pipeline_frequency).freq_type;
                    formData['deleteType']['text_value'] = masterTable ? 'entire_data' : JSON.parse(el.pipeline_frequency).deleteType;
                    formData['minsplit']['text_value'] = JSON.parse(el.pipeline_frequency).minsplit;
                    formData['datasplit']['text_value'] = JSON.parse(el.pipeline_frequency).datasplit;
                    formData['time_to_subtract']['text_value'] = JSON.parse(el.pipeline_frequency).time_to_subtract;
                    if (eventDetails.connection_type === 'sftp') {
                        formData['filePattern']['text_value'] = JSON.parse(el.pipeline_frequency).filePattern;
                    }
                } else {
                    formData['status']['text_value'] = "";
                    formData['freq_type']['text_value'] = "";
                    formData['minsplit']['text_value'] = "";
                    formData['datasplit']['text_value'] = "";
                    formData['deleteType']['text_value'] = masterTable ? 'entire_data' : "";
                    formData['time_to_subtract']['text_value'] = ""
                    formData['limit']['text_value'] = ''
                    if (eventDetails.connection_type === 'sftp') {
                        formData['filePattern']['text_value'] = ""
                    }
                }
                if (el.pipeline_frequency && JSON.parse(el.pipeline_frequency).freq_type == "daily") {
                    formData['timeOfDay']['type'] = "time";
                    formData['timeOfDay']['text_value'] = JSON.parse(el.pipeline_frequency).timeOfDay;
                } else if (el.pipeline_frequency && JSON.parse(el.pipeline_frequency).freq_type == "week") {
                    formData['timeOfDay']['type'] = "time";
                    formData['timeOfDay']['text_value'] = JSON.parse(el.pipeline_frequency).timeOfDay;
                    formData['dayOfWeek']['type'] = "dropdown";
                    formData['dayOfWeek']['text_value'] = JSON.parse(el.pipeline_frequency).dayOfWeek;
                } else if (el.pipeline_frequency && JSON.parse(el.pipeline_frequency).freq_type == "month") {
                    formData['timeOfDay']['type'] = "time";
                    formData['timeOfDay']['text_value'] = JSON.parse(el.pipeline_frequency).timeOfDay;
                    formData['dayOfMonth']['type'] = "number";
                    formData['dayOfMonth']['text_value'] = JSON.parse(el.pipeline_frequency).dayOfMonth;
                }
                update_information.push({
                    "connectionId": el.connectionId,
                    "id": el.id,
                    "pipeline_frequency": { "path": eventDetails.fileInfo.pipeline_frequency ? JSON.parse(eventDetails.fileInfo.pipeline_frequency).folderPath : null },
                    "rockmetric_update": true,
                    "rockmetric_update_columns": ['pipeline_frequency'],
                    'masterTable': masterTable
                })
            }
        })
        setdataToSend({ 'update_information': [...update_information] })
    } else if (clickName === "makeDataset") {
        formData = JSON.parse(JSON.stringify(formUpload[`${clickName}Form`]));
        let dateColumnOptions = [{ "name": "Select Option", "value": "" }]
        let parsedInfo = eventDetails.fileInfo && eventDetails.fileInfo.information
            ? JSON.parse(eventDetails.fileInfo.information)
            : null
        parsedInfo && parsedInfo.dateArray && parsedInfo.dateArray.map(function (innerData) {
            dateColumnOptions.push({ 'name': innerData, 'value': innerData })
        })
        formData['dateColumn']['options'] = dateColumnOptions
        setdataToSend({
            "tableName": eventDetails.tableName,
        })
    } else if (clickName === "overWrite") {
        let overwrite_information = [];
        let dateColumnSelected = null;
        if (eventDetails.connection_type === "sftp") {
            formData = JSON.parse(JSON.stringify(formUpload[`${clickName}Form`]));
            formData.connectionId = eventDetails.connectionId;
            formData.connection_name = eventDetails.tableName;
            formData.targetTable = eventDetails.virtualTableName;
            formData.connection_type = eventDetails.connection_type;
        }
        renderData.map(el => {
            if (eventDetails['tableName'] === el.targetTableName) {
                let masterTable = ['Master', 'master'].indexOf(el.type) > -1
                if (masterTable) {
                    formData['overwriteType']['text_value'] = 'full';
                    formData['overwriteType']['disabled'] = true;
                    formData['limit']['type'] = 'number'
                    formData['dateColumn']['type'] = "hide";
                    formData['startDate']['type'] = "hide";
                    formData['endDate']['type'] = "hide";
                    formData['min_split']['type'] = "hide";
                    formData['data_split']['type'] = "hide";
                    formData['dataset']['type'] = "hide";
                    formData['truncateData']['type'] = 'dropdown'
                    formData['truncateData']['text_value'] = false
                } else {
                    formData['overwriteType']['text_value'] = null;
                    formData['fileName']['type'] = "hide";
                    formData['fileName']['text_value'] = null;
                    formData['dateColumn']['type'] = "text";
                    dateColumnSelected = JSON.parse(el.information).dateColumn;
                    formData['dateColumn']['text_value'] = dateColumnSelected;
                    formData['startDate']['type'] = "date";
                    formData['startDate']['text_value'] = null;
                    formData['endDate']['type'] = "date";
                    formData['endDate']['text_value'] = null;
                    formData['data_split']['type'] = "dropdown";
                    formData['data_split']['text_value'] = null;
                    formData['min_split']['type'] = "dropdown";
                    formData['min_split']['text_value'] = null;
                    formData['dataset']['type'] = "hide";
                    formData['limit']['type'] = 'hide'
                }
                overwrite_information.push({
                    "connectionId": el.connectionId,
                    "connection_type": el.connection_type,
                    "clientTableName": el.clientTableName,
                    "clientDBName": el.clientDBName,
                    "virtualTableName": el.virtualTableName,
                    "targetTable": el.targetTableName,
                    "action": "overwrite",
                    "dateColumn": dateColumnSelected,
                    "masterTable": masterTable
                })
            }
        })
        if (eventDetails.connection_type === "manual") {
            formData['dateColumn']['type'] = "hide";
            formData['startDate']['type'] = "hide";
            formData['endDate']['type'] = "hide";
            formData['data_split']['type'] = "hide";
            formData['min_split']['type'] = "hide";
            formData['dataset']['type'] = "newFile";
        } else if (eventDetails.connection_type === "sftp") {
            formData['dateColumn']['type'] = "hide";
            formData['startDate']['type'] = "hide";
            formData['endDate']['type'] = "hide";
            formData['data_split']['type'] = "hide";
            formData['min_split']['type'] = "hide";
            formData['dataset']['type'] = "hide";
        }
        setdataToSend({ 'pull_information': [...overwrite_information] })
    } else if (clickName === "dataQuality") {
        formData = JSON.parse(JSON.stringify(formUpload[`${clickName}Form`]));
        let dataquality_info = []
        if (eventDetails.tableName !== undefined) {
            formData['dataType']['type'] = 'dropdown'
            formData['dataType']['text_value'] = 'pdf'
            dataquality_info.push({
                "tableName": eventDetails.tableName,
                "api_request": true
            })
        } else {
            formData['dataQualityType']['type'] = 'dropdown'
            dataquality_info.push({
                "tableName": renderData[0].targetTable,
                "where": { "rm_file_name": eventDetails.fileInfo.fileName },
                "connectionId": eventDetails.fileInfo.connectionId,
                "compare": {
                    "rm_file_name": [eventDetails.fileInfo.fileName]
                },
                "api_request": true
            })
        }
        setdataToSend({ 'pull_information': [...dataquality_info] })
    } else if (clickName === "delete") {
        formData = JSON.parse(JSON.stringify(formUpload[`${clickName}Form`]));
        formData['message']['text_value'] = "Yes"
        formData['message']['disabled'] = true
        let delete_info = [];
        renderData.map(el => {
            if (eventDetails.connection_type && eventDetails.connection_type !== null && eventDetails.connection_type !== undefined && eventDetails.virtualTableName === el.virtualTableName) {
                delete_info.push({
                    "id": el.id,
                    "information": "folderDeletion",
                })
            } else if (eventDetails.fileInfo && eventDetails.fileInfo.fileName !== null && eventDetails.fileInfo.fileName !== undefined && eventDetails.fileInfo.fileName === el.fileName && eventDetails.fileInfo.logTableId === el.logTableId) {
                delete_info.push({
                    "connectionId": el.connectionId,
                    "targetTable": el.targetTable,
                    "logTableId": el.logTableId,
                    "action": "delete",
                    "overwriteCondition": { "fileName": [el.fileName] }
                })
            }
        })
        setdataToSend({ 'pull_information': [...delete_info] })
    } else if (clickName === "update") {
        formData = JSON.parse(JSON.stringify(formUpload[`${clickName}Form`]));
        formData['virtualTableName']['text_value'] = eventDetails.virtualTableName
        formData['type']['text_value'] = capitalizeFirstChar(eventDetails.fileInfo.type)
        if (eventDetails.connection_type === "sftp" || eventDetails.connection_type === "manual") {
            formData["default_newColumns"]["type"] = "dropdown"
        }
        let update_information = [];
        renderData.map(el => {
            if (eventDetails['tableName'] === el.targetTableName) {
                update_information.push({
                    "connectionId": el.connectionId,
                    "id": el.id,
                    "rockmetric_update": true,
                    "rockmetric_update_columns": [],
                    "virtualTableName": el.virtualTableName
                })
            }
        })
        setdataToSend({ 'update_information': [...update_information] })
    }

    let config = JSON.parse(JSON.stringify(modalConfig[`${clickName}Modal`]));
    if (eventDetails.connection_type === 'sftp' && clickName === 'updateSettings') {
        config['title'] = <>{`${config['title']}`}<span> ({`${eventDetails.fileInfo.pipeline_frequency}` ? `Path: ${JSON.parse(eventDetails.fileInfo.pipeline_frequency).folderPath}` : null})</span></>
    } else if (eventDetails.tableName !== undefined) {
        config['title'] = <>{`${config['title']}`}<span> ({`${eventDetails.virtualTableName}`})</span></>
    } else config['title'] = <>{`${config['title']}`}<span> ({`${eventDetails.fileInfo.fileName}`})</span></>;

    config['formKey'] = `${clickName}Form_${Math.floor(Math.random() * 10)}`;
    config['isLoading'] = false;
    setmodalToView({ modal: config, formData: formData, type: clickName });
    setTimeout(() => {
        jQuery(`#${clickName}Modal`).modal('toggle');
    }, 5);
}

export function MappingEvent(folderDetails, setmodalToView, setdataToSend) {
    let formDataFile = JSON.parse(JSON.stringify(formUpload['mappingForm']));
    let formDataDB = JSON.parse(JSON.stringify(formUpload['mappingForm']));
    let errorMessage = JSON.parse(folderDetails.pull_info).error_message
    let mapping_info = []

    let optionFromMapping = [
        { "name": "Select Option", "value": "" },
        { "name": "Ignore Column", "value": "ignoreColumn" },
        { "name": "Add Column", "value": "addColumn" }
    ];

    if (errorMessage) {
        if (errorMessage.file_missing) {
            errorMessage.file_missing.map(function (innerData) {
                optionFromMapping.push({ name: innerData, value: innerData })
            })
            errorMessage.file_missing.map((innerData) => {
                formDataDB[`dropdown${innerData}`] = { ...mappingDropDown }
                formDataDB[`dropdown${innerData}`]['name'] = innerData
                formDataDB[`dropdown${innerData}`]['label'] = innerData
                formDataDB[`dropdown${innerData}`]['options'] = [
                    { "name": "Select Option", "value": "" },
                    { "name": "Ignore Column", "value": "ignoreColumn" }
                ]
            })
        }
        if (errorMessage.db_missing) {
            errorMessage.db_missing.map((innerData) => {
                formDataFile[`dropdown${innerData}`] = { ...mappingDropDown }
                formDataFile[`dropdown${innerData}`]['name'] = innerData
                formDataFile[`dropdown${innerData}`]['label'] = innerData
                formDataFile[`dropdown${innerData}`]['options'] = optionFromMapping
            })
        }


        mapping_info.push({
            "targetTable": folderDetails.targetTable,
            "mapping_sent": {},
            "ignoreColumns": { "file_columns": [], "db_columns": [] },
            "newColumns": [],
            "action": "append",
        })
    }
    setdataToSend({ 'pull_information': [...mapping_info] })

    let config = JSON.parse(JSON.stringify(modalConfig['mappingModal']));
    config['title'] = <>{`${config['title']}`}<span><small>({`${folderDetails.fileName}`})</small></span></>;
    config['formKey'] = `mappingForm_${Math.floor(Math.random() * 10)}`;
    config['isLoading'] = false;
    setmodalToView({
        modal: config,
        formData: { "fileMapping": { "label": "File Column Mapping", "body": formDataFile }, "dbMapping": { "label": "Unmapped DB Column", "body": formDataDB } },
        errorMessage: errorMessage,
        folderDetails: folderDetails,
        type: 'mapping'
    });
    setTimeout(() => {
        jQuery('#mappingModal').modal('toggle');
    }, 5);
}

export function RefreshEvent(e, modalToView, setmodalToView) {
    let tempModalData = { ...modalToView };
    let tempSelectedFiles = [];
    let errorMessage = modalToView.errorMessage;
    let formDataDB = {}
    if (tempModalData.formData) {
        Object.keys(tempModalData.formData['fileMapping'].body).map(function (formKey) {
            let selectedValue = document.getElementById(`${tempModalData.formData['fileMapping']['body'][formKey]['name']}_form_data`).value;
            if (selectedValue) {
                tempModalData.formData['fileMapping']['body'][formKey]['text_value'] = selectedValue;
                tempSelectedFiles.push(selectedValue);
            }
        })
        if (errorMessage.file_missing) {
            tempModalData.errorMessage.file_missing.map((innerData) => {
                if (tempSelectedFiles.indexOf(innerData) == -1) {
                    formDataDB[`dropdown${innerData}`] = { ...mappingDropDown }
                    formDataDB[`dropdown${innerData}`]['name'] = innerData
                    formDataDB[`dropdown${innerData}`]['label'] = innerData
                    formDataDB[`dropdown${innerData}`]['options'] = [
                        { "name": "Select Option", "value": "" },
                        { "name": "Ignore Column", "value": "ignoreColumn" }
                    ]
                }
            })
        }
        tempModalData.formData['dbMapping'].body = formDataDB
    }
    setmodalToView(tempModalData);
}

const getOverwriteOptions = (tableName, connectionId, setmodalToView, modalToView, authData, fileName) => {
    let tempFormData = { ...modalToView };
    let params = { "siteId": authData.siteId, "tableName": tableName, "connectionId": connectionId };

    CallAPI('get', '/app/get_pulled_file_list', null, params, 0, function (response) {
        let fileOptions = [{ "name": "Select Option", "value": "" }];
        if (response.status === true) {
            response.information.fileInfo.map(function (innerData) {
                if (innerData['data_summary'] == 1)
                    fileOptions.push({ 'name': innerData.fileName, 'value': innerData.fileName });
            })
        }
        if (modalToView.type === "dataQuality") {
            let fileArray = []
            fileOptions.map(function (innerData) {
                if (innerData.value === fileName) {
                    fileArray = fileOptions.filter(item => item.value !== fileName);
                }
            })
            if (fileArray.length === 1) {
                fileArray.push({ "name": "No more files in this table", "value": "" })
            }
            tempFormData.formData['fileName']['options'] = fileArray;
        } else {
            if (fileOptions.length === 1) {
                fileOptions.push({ "name": "No more successful files in this table", "value": "" })
            }
            tempFormData.formData['fileName']['options'] = fileOptions;
        }
        tempFormData.modal['formKey'] = `${tempFormData.type}Form_${Math.random()}`;
        setmodalToView(tempFormData);
    }, authData)
}

export function modalOnChangeHandle(e, modalToView, setmodalToView) {
    let tempFormData = { ...modalToView.formData };
    tempFormData[e.target.name].text_value = e.target.value;
    setmodalToView({ ...modalToView, formData: tempFormData });
}

export function modalDropDownEvents(e, modalToView, setmodalToView, authData, dataToSend) {
    let tempFormData = modalToView.formData;
    tempFormData[e.target.name].text_value = e.target.value;
    if (e.target.name == "freq_type") {
        switch (e.target.value) {
            case "":
            case "yearly":
                tempFormData['timeOfDay']['type'] = "hide";
                tempFormData['dayOfWeek']['type'] = "hide";
                tempFormData['dayOfMonth']['type'] = "hide";
                break;
            case "daily":
                tempFormData['timeOfDay']['type'] = "time";
                tempFormData['dayOfWeek']['type'] = "hide";
                tempFormData['dayOfMonth']['type'] = "hide";
                break;
            case "week":
                tempFormData['timeOfDay']['type'] = "time";
                tempFormData['dayOfMonth']['type'] = "hide";
                tempFormData['dayOfWeek']['type'] = "dropdown";
                break;
            case "month":
                tempFormData['timeOfDay']['type'] = "time";
                tempFormData['dayOfWeek']['type'] = "hide"
                tempFormData['dayOfMonth']['type'] = "number";
                break;
        }
    } else if (e.target.name == "overwriteType" || e.target.name === "compare_type") {
        if (e.target.value == "file" || e.target.value === "2") {
            let tableName = dataToSend['pull_information'][0]['targetTable'] || dataToSend['pull_information'][0]['tableName'];
            let connectionId = dataToSend['pull_information'][0]['connectionId'];
            let fileName = dataToSend['pull_information'][0]['compare'] ? Object.assign({}, dataToSend['pull_information'][0]['compare']['rm_file_name'])[0] : null
            getOverwriteOptions(tableName, connectionId, setmodalToView, modalToView, authData, fileName)
            tempFormData['fileName']['type'] = "dropdown"
        } else {
            tempFormData['fileName']['type'] = "hide"
        }
    } else if (e.target.name === "dataQualityType") {
        switch (e.target.value) {
            case "currentFile":
                tempFormData['dataType']['type'] = 'dropdown'
                tempFormData['dataType']['text_value'] = 'pdf'
                tempFormData['compare_type']['type'] = 'hide'
                tempFormData['difference']['type'] = 'hide'
                break;
            case "compareFile":
                tempFormData['dataType']['type'] = 'hide'
                tempFormData['compare_type']['type'] = 'dropdown'
                tempFormData['difference']['type'] = 'dropdown'
                break;
            case "":
                tempFormData['dataType']['type'] = 'hide'
                tempFormData['compare_type']['type'] = 'hide'
                tempFormData['difference']['type'] = 'hide'
        }
    } else if (e.target.name === "filePattern") {
        if (e.target.value === 'custom') {
            tempFormData['customFilePattern']['type'] = 'text'
        } else tempFormData['customFilePattern']['type'] = 'hide'
    } else if (e.target.name === 'min_split') {
        if (e.target.value !== '') {
            tempFormData['data_split']['requiredFlag'] = true
        } else tempFormData['data_split']['requiredFlag'] = false
    } else if (e.target.name === 'data_split') {
        if (e.target.value !== '') {
            tempFormData['min_split']['requiredFlag'] = true
        } else tempFormData['min_split']['requiredFlag'] = false
    }
    let tempModal = modalToView.modal;
    if (e.target.name === "customFilePattern") {
        setmodalToView({ ...modalToView, formData: tempFormData });
    } else {
        tempModal['formKey'] = `${modalToView.type}Form_${Math.floor(Math.random() * 10)}`;
        setmodalToView({ ...modalToView, formData: tempFormData, modal: tempModal });
    }
}